import React, { createContext, useState } from 'react'
import { useToggle } from 'hooks'
import ConfirmationModal from './index'

export const ConfirmationModalContext = createContext({})

export const ConfirmationModalProvider = ({ children }) => {
    const { isOpen, onOpen, onClose } = useToggle()
    const [dialogConfig, setDialogConfig] = useState({})

    const openDialog = ({ title, message, buttons, actionCallback }) => {
        onOpen()
        setDialogConfig({ title, message, buttons, actionCallback })
    }

    const resetDialog = () => {
        onClose()
        setDialogConfig({})
    }

    const onConfirm = () => {
        resetDialog()
        dialogConfig.actionCallback(true)
    }

    const onDismiss = () => {
        resetDialog()
        dialogConfig.actionCallback(false)
    }

    return (
        <ConfirmationModalContext.Provider value={{ openDialog }}>
            <ConfirmationModal
                isOpen={isOpen}
                title={dialogConfig.title}
                message={dialogConfig.message}
                onConfirm={onConfirm}
                onDismiss={onDismiss}
                buttons={dialogConfig.buttons}
            />
            {children}
        </ConfirmationModalContext.Provider>
    )
}
